import {
  Typography,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Tooltip,
  Button,
  Stack,
} from "@mui/material";

import InfoIcon from "@mui/icons-material/Info";

import { makeStyles } from "@mui/styles";
import OperatingHours from "../../../../pages/Login/OperatingHours";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
}));

const daysOfWeek = [
  { label: "Monday", value: "mon" },
  { label: "Tuesday", value: "tue" },
  { label: "Wednesday", value: "wed" },
  { label: "Thursday", value: "thu" },
  { label: "Friday", value: "fri" },
  { label: "Saturday", value: "sat" },
  { label: "Sunday", value: "sun" },
];

const CustomerForm = (props) => {
  const classes = useStyles();
  const { customer, paymentType, handleChange, handlePaymentTypeChange } =
    props;

  const handleChangeOperatingHours = (value) => {
    handleChange({
      target: {
        name: "operating_hours",
        value,
      },
    });
  };

  return (
    <>
      <form
        className={classes.form}
        margin="dense"
        noValidate
        autoComplete="off"
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={12} key={`customer_${customer.id}`}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  required={true}
                  variant="outlined"
                  label="Name: "
                  name="name"
                  value={customer && customer.name}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Phone Number: "
                  name="phone_number"
                  value={(customer && customer.phone_number) || ""}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Sale Tax Rate: "
                  name="sales_tax_rate"
                  type="number"
                  value={(customer && customer.sales_tax_rate) || 0}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Refrigerated Delivery Fee: "
                  name="refrigerated_delivery_fee"
                  type="number"
                  value={(customer && customer.refrigerated_delivery_fee) || 0}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Late Order Fee: "
                  name="late_order_fee"
                  type="number"
                  value={(customer && customer.late_order_fee) || 0}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Credit Card Charge Fee: "
                  name="credit_card_charge_fee"
                  type="number"
                  value={(customer && customer.credit_card_charge_fee) || 0}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Fuel Surcharge Fee: "
                  name="fuel_surcharge_fee"
                  type="number"
                  value={(customer && customer.fuel_surcharge_fee) || 0}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Omit Delivery Fee Threshold: "
                  name="omit_delivery_fee_threshold"
                  type="number"
                  value={
                    (customer && customer.omit_delivery_fee_threshold) || 0
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="taxable"
                      value={customer && customer.taxable}
                      checked={customer && customer.taxable}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Taxable"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Internal Notes: "
                  name="internal_notes"
                  value={(customer && customer.internal_notes) || ""}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="QB Mapping: "
                  name="qb_mapping"
                  value={(customer && customer.qb_mapping) || ""}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="units_quickbooks_mappings"
                      value={customer && customer.units_quickbooks_mappings}
                      checked={customer && customer.units_quickbooks_mappings}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Units Quickbooks Mappings"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ display: "none" }}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="fuel_surcharge"
                      value={customer && customer.fuel_surcharge}
                      checked={customer && customer.fuel_surcharge}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Fuel Surcharge"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="lot_tracking_enabled"
                      value={customer && customer.lot_tracking_enabled}
                      checked={customer && customer.lot_tracking_enabled}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Enable Lot Tracking"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  value="start"
                  control={
                    <Checkbox
                      name="customer_editable_orderlist_enabled"
                      value={
                        customer && customer.customer_editable_orderlist_enabled
                      }
                      checked={
                        customer && customer.customer_editable_orderlist_enabled
                      }
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label="Enable Customer Editable Order Guide"
                  labelPlacement="end"
                />
                <Tooltip title="If enabled, the customer can edit their order guide categories and products through the customer section. This also enable search ability, storefront and add to guide from products.">
                  <InfoIcon color="action" fontSize="small" />
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography
                  color="primary"
                  component="h4"
                  style={{ textAlign: "center" }}
                >
                  Business hours
                  <Tooltip title="Business hours: Configure the operating hours for the customer. This is used for informational purposes.">
                    <InfoIcon color="action" fontSize="small" />
                  </Tooltip>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <OperatingHours
                  value={customer.operating_hours}
                  onChange={handleChangeOperatingHours}
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                <Typography color="primary" component="h4">
                  Order Days & Delivery Hour
                </Typography>
              </Grid>
              <Grid item xs={12} sm={"auto"}>
                <FormGroup component="fieldset" variant="standard">
                  {daysOfWeek.map((day) => (
                    <FormControlLabel
                      key={day.value}
                      value="start"
                      control={
                        <Checkbox
                          name={`order_days-${day.value}`}
                          value={
                            customer?.order_days?.includes(day.value) || false
                          }
                          checked={
                            customer?.order_days?.includes(day.value) || false
                          }
                          onChange={handleChange}
                          color="primary"
                        />
                      }
                      label={day.label}
                      labelPlacement="end"
                    />
                  ))}
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  size="small"
                  variant="outlined"
                  type="time"
                  label="Delivery Hour"
                  name="delivery_time"
                  value={customer?.delivery_time || ""}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                <Typography color="primary" component="h4">
                  Payment Settings
                  <Tooltip title="Payment settings: No Payments. Payments is used to allow admins to mark an Invoice as payable and the customer is able to pay the invoice. Cash on delivery will allow admins to finalize invoices and charge the customer's default payment method configured by the customer when placing an order.">
                    <InfoIcon color="action" fontSize="small" />
                  </Tooltip>
                </Typography>
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                  style={{ marginTop: 8 }}
                >
                  <Button
                    variant="contained"
                    color={paymentType === 0 ? "primary" : "inherit"}
                    onClick={() => handlePaymentTypeChange(0)}
                  >
                    No Payments
                  </Button>
                  <Button
                    variant="contained"
                    color={paymentType === 1 ? "primary" : "inherit"}
                    onClick={() => handlePaymentTypeChange(1)}
                  >
                    Payments on Terms
                  </Button>
                  <Button
                    variant="contained"
                    color={paymentType === 2 ? "primary" : "inherit"}
                    onClick={() => handlePaymentTypeChange(2)}
                  >
                    Pay in Advance CC
                  </Button>
                  <Button
                    variant="contained"
                    color={paymentType === 3 ? "primary" : "inherit"}
                    onClick={() => handlePaymentTypeChange(3)}
                  >
                    COD Cash
                  </Button>
                </Stack>
              </Grid>
              {paymentType === 1 && (
                <>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      fullWidth
                      InputProps={{
                        inputProps: { min: 0, max: 15 },
                      }}
                      type="number"
                      size="small"
                      variant="outlined"
                      label="On Time Payment Discount Amount: "
                      name="on_time_payment_discount_amount"
                      value={
                        (customer &&
                          customer.on_time_payment_discount_amount) ||
                        ""
                      }
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      fullWidth
                      type="number"
                      InputProps={{
                        inputProps: { min: 0, max: 60 },
                      }}
                      size="small"
                      variant="outlined"
                      label="On Time Payment Days Threshold: "
                      name="on_time_payment_days_threshold"
                      value={
                        (customer && customer.on_time_payment_days_threshold) ||
                        ""
                      }
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                <Typography color="primary" component="h4">
                  Billing Address
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Address Line 1: "
                  name="billing_address-address_line1"
                  value={
                    (customer.billing_address &&
                      customer.billing_address.address_line1) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Address Line 2: "
                  name="billing_address-address_line2"
                  value={
                    (customer.billing_address &&
                      customer.billing_address.address_line2) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="City: "
                  name="billing_address-city"
                  value={
                    (customer.billing_address &&
                      customer.billing_address.city) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      maxLength: 2,
                    },
                  }}
                  size="small"
                  variant="outlined"
                  label="State: "
                  name="billing_address-state"
                  value={
                    (customer.billing_address &&
                      customer.billing_address.state) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Zip: "
                  name="billing_address-zip"
                  value={
                    (customer.billing_address &&
                      customer.billing_address.zip) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                <Typography color="primary" component="h4">
                  Physical Address
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Address Line 1: "
                  name="physical_address-address_line1"
                  value={
                    (customer.physical_address &&
                      customer.physical_address.address_line1) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Address Line 2: "
                  name="physical_address-address_line2"
                  value={
                    (customer.physical_address &&
                      customer.physical_address.address_line2) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="City: "
                  name="physical_address-city"
                  value={
                    (customer.physical_address &&
                      customer.physical_address.city) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  InputProps={{
                    inputProps: {
                      maxLength: 2,
                    },
                  }}
                  size="small"
                  variant="outlined"
                  label="State: "
                  name="physical_address-state"
                  value={
                    (customer.physical_address &&
                      customer.physical_address.state) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="Zip: "
                  name="physical_address-zip"
                  value={
                    (customer.physical_address &&
                      customer.physical_address.zip) ||
                    ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                <Typography color="primary" component="h4">
                  CC Emails
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="CC 1: "
                  name="cc_addresses-0"
                  value={
                    (customer.cc_addresses && customer.cc_addresses[0]) || ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="CC 2: "
                  name="cc_addresses-1"
                  value={
                    (customer.cc_addresses && customer.cc_addresses[1]) || ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="CC 3: "
                  name="cc_addresses-2"
                  value={
                    (customer.cc_addresses && customer.cc_addresses[2]) || ""
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label="CC 4: "
                  name="cc_addresses-3"
                  value={
                    (customer.cc_addresses && customer.cc_addresses[3]) || ""
                  }
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default CustomerForm;
